import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { NavLink, Link } from 'react-router-dom'

// Redux:
import { getForumData } from 'actions/forum'

class ForumMenu extends React.Component {
	// handleClick = () => {
	// 	let slug = e.currentTarget.getAttribute( 'data-slug' )

	// 	this.props.getForum( slug )
	// }

	getTopics = ( forum ) => {
		let markup = ''

		if ( forum.topics && Object.keys( forum.topics ).length ) {
			markup = Object.keys( forum.topics )
				.map( key => {
					let item = forum.topics[ key ]

					return (
						<li key={ item.id }>
							<NavLink
								to={ `/forum/${forum.slug}/${item.slug}` }
								exact
								activeClassName="is-active"
								dangerouslySetInnerHTML={ { __html: item.title.rendered } }
							/>
						</li>
					)
				})
		}

		if ( markup ) {
			return (
				<div className="-dropdown">
					<ul>
						{ markup }
					</ul>
				</div>
			)
		}

		return markup
	}

	render() {
		const { forumById } = this.props

		document.title = siteData.site_name + ' - Forum'

		let forumsMenuMarkup = ''

		if ( forumById && Object.keys( forumById ).length ) {
			forumsMenuMarkup = Object.keys( forumById )
				.map( key => {
					let item = forumById[ key ],
						topics = this.getTopics( item )

					if ( ! item.title ) {
						return
					}

					return (
						<li key={ item.id }>
							<NavLink
								to={ `/forum/${item.slug}` }
								activeClassName="is-active"
								dangerouslySetInnerHTML={ { __html: item.title.rendered } }
							/>

							{ topics }
						</li>
					)
				})
		}

		return (
			<div className="secondary-menu forum-menu">
				<h3>
					<Link to="/forum">Forums</Link>
				</h3>

				<ul className="-menu">
					{ forumsMenuMarkup }
				</ul>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		forumById: state.forum.forumById,
		topic: state.forum.selectedTopic,
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getForumData( slug ) {
			dispatch( getForumData( slug ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( ForumMenu )



// WEBPACK FOOTER //
// ./views/main/Forum/ForumMenu.jsx